<template>
  <div class="coupon" mg-stat-mod="couponlist">
    <fixed-header title="芒果好物"></fixed-header>
    <div class="coupon__main scroll-touch">
      <div class="coupon__goods" mg-stat-mod="couponlist">
        <div v-for="(item, index) in list" :key="index" :class="['coupon__goods-item',getClass(index)]"
             :mg-stat-custom="`cont=${item.goodsId}&label=goods&direct=cntp&addr=haowu_goods_detail`"
             :mg-stat-lob="`goodsdc=${goodsdc}`"
             mg-stat-click mg-stat-mod="goods_list"
             @click="gotoGoodsDetail(item)">
          <section :mg-stat-lob="`smod=1&sp_id${id}&goods_id=${item.goodsId}&stype=2`"
                   class="coupon__goods-img"
                   mg-stat-show="flag=200"
          >
            <img :src="item.originalImg">
          </section>
          <div class="coupon__goods-desc">
            <section class="add_dot2">{{ item.goodsName }}</section>
            <section>
              <div>
                <span class="price">¥{{ item.shopPrice }}</span>
                <span class="vip">
                  <span class="vtag">VIP</span>
                  <span class="tag">￥</span>{{ item.memberGoodsPrice }}
                </span>
              </div>
              <!-- <div @click.stop="addCart(item.goodsId)"><i class="icon home_cart"></i></div> -->
            </section>
          </div>
        </div>
      </div>
    </div>
    <nav-button></nav-button>
  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';
import PageLoading from 'components/common/PageLoading';
import NavButton from 'components/common/NavButton';
import { handleGoodsPrice } from 'utils/goods';
import { beforeRouteChange, initCloseUpload, setFixedParams, uploadAccessData, uploadCloseData } from 'utils/uploadData';
import DataStorage from 'utils/dataStore';
import { coupongoods } from 'apis/member';
import { guid } from 'utils/index';

export default {
  components: {
    FixedHeader, PageLoading, NavButton,
  },
  data() {
    const { id } = this.$route.query;
    return {
      id,
      list: [],
      goodsId: 0,
      shareContent: null,
      hasRouteChange: false,
      hasAnyAction: false,
      goodsdc: this.guid(),
    };
  },
  watch: {
    hasAnyAction: {
      handler(val) {
        DataStorage.setPageVisitiLog(val);
      },
      immediate: true,
    },
  },
  async created() {
    this.fetchcouponDetail();
    await setFixedParams(this);
    uploadAccessData();
  },
  mounted() {
    initCloseUpload();
  },
  beforeRouteLeave(to, from, next) {
    if (!this.hasRouteChange) {
      uploadCloseData();
    }
    next();
  },
  methods: {
    guid,
    handleGoodsPrice,
    gotoGoodsDetail(item) {
      this.hasAnyAction = true;
      beforeRouteChange({ path: '/goods/detail', query: { id: item.goodsId, showBack: 1, goodsdc: this.goodsdc } }, this);
    },
    addCart(id) {
      this.goodsId = id;
      this.isShowSkuParams = true;
    },
    getClass(index) {
      return (index + 1) % 2 === 0 ? 'item-right' : 'item-left';
    },
    async fetchcouponDetail() {
      const data = await coupongoods(this.id);
      if (data) {
        this.list = data;
      }
    },
  },
};

</script>
<style lang="scss" scoped>
.coupon {
  height: 100%;

  .item-left {
    padding-right: 10px;
  }

  .item-right {
    padding-left: 10px;
  }

  &__main {
    padding: 20px 20px 120px 20px;
    box-sizing: border-box;
    height: 100%;
    background: #F2F2F2;
  }

  &__banner {
    height: 267px;
    background: burlywood;

    img {
      width: 100%;
      height: 100%;
    }
  }

  &__tags {
    height: 27px;
    overflow: hidden;

    span {
      height: 27px;
      box-sizing: border-box;
      line-height: 27px;
      border-radius: 12px;
      padding: 0px 12px;
      font-size: 16px;
      color: #ff5f00;
      background: rgba(255, 95, 0, 0.15);
      float: left;

      & + span {
        margin-left: 5px;
      }
    }
  }

  &__goods {
    display: flex;
    flex-wrap: wrap;

    &-item {
      width: 50%;
      margin-top: 20px;
      box-sizing: border-box;
    }

    &-desc {
      padding: 15px 10px;
      background: #fff;

      section {
        &:nth-of-type(1) {
          height: 75px;
          line-height: 1.4;
          font-size: 28px;
          /* padding: 10px 0; */
        }

        .price {
          line-height: 0.733333rem;
          font-size: 0.453333rem;
          color: #ff5f00;
          margin-right: 0.133333rem;
        }

        .vip {
          text-decoration: none;
          margin-left: 10px;
          font-size: 22px;
          height: 32px;
          line-height: 32px;
          color: rgba(40, 35, 35, 1);
          background-size: 108px 32px;
          background-color: #FAEFE1;
          box-sizing: border-box;
          padding-right: 5px;
          border-radius: 4px;
          padding: 2px 5px 3px 0px;

          .vtag {
            line-height: 32px;
            padding: 2px 5px 3px 5px;
            height: 32px;
            text-decoration: none;
            border-top-left-radius: 4px;
            border-bottom-left-radius: 4px;
            font-size: 22px;
            color: #fff;
            background-color: #282323;
          }

          .tag {
            font-size: 12px;
            color: rgba(40, 35, 35, 1);
            text-decoration: none;
            border: none;
            margin-left: 2px;
          }
        }
      }
    }

    &-img {
      height: 345px;

      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
